import React from 'react'

import { Slide } from '@material-ui/core'

const slideUp = React.forwardRef( ( props , ref ) => <Slide ref={ref} direction="up" {...props} /> ) ;

export default slideUp ;
